import Typography from '@mui/material/Typography';

export const NoRates = () => {
  return (
    <Typography>No rates found. Add some above to get started!</Typography>
  );
};
